import { lazy } from 'react'
import { Redirect } from 'react-router'
import { RouteConfig } from 'react-router-config'

const routes: RouteConfig[] = [
  {
    path: '/',
    component: lazy(() => import('@/pages/lna/layout')),
    routes: [
      {
        path: '/transit',
        exact: true,
        component: lazy(() => import('@/pages/lna/pay/pc/transit')),
      },
      // 官网支付
      {
        path: '/shopStore',
        component: lazy(() => import('@/pages/lna/pay_new/pc')),
        routes: [
          {
            path: '/shopStore/selectOrder',
            component: lazy(() => import('@/pages/lna/pay_new/pc/giftList')),
          },
          {
            path: '/shopStore/help-center',
            component: lazy(() => import('@/pages/lna/pay_new/pc/helpCenter')),
          },
          {
            path: '/shopStore/pay',
            component: lazy(() => import('@/pages/lna/pay_new/pc/pay')),
          },
          {
            path: '/shopStore/wait-order',
            component: lazy(() => import('@/pages/lna/pay_new/pc/waitOrder')),
          },
          {
            path: '/shopStore/fail-order',
            component: lazy(() => import('@/pages/lna/pay_new/pc/failOrder')),
          },
        ],
      },
      {
        path: '/m/transit',
        exact: true,
        component: lazy(() => import('@/pages/lna/pay/mobile/transit')),
      },
      /* 支付--mobile */
      {
        path: '/m/shopStore',
        component: lazy(() => import('@/pages/lna/pay_new/mobile')),
        routes: [
          {
            path: '/m/shopStore/selectOrder',
            component: lazy(
              () => import('@/pages/lna/pay_new/mobile/giftList')
            ),
          },
          {
            path: '/m/shopStore/help-center',
            component: lazy(
              () => import('@/pages/lna/pay_new/mobile/helpCenter')
            ),
          },
          {
            path: '/m/shopStore/pay',
            component: lazy(() => import('@/pages/lna/pay_new/mobile/pay')),
          },
          {
            path: '/m/shopStore/wait-order',
            component: lazy(
              () => import('@/pages/lna/pay_new/mobile/waitOrder')
            ),
          },
          {
            path: '/m/shopStore/fail-order',
            component: lazy(
              () => import('@/pages/lna/pay_new/mobile/failOrder')
            ),
          },
        ],
      },
    ],
  },
]

export default routes
